// extracted by mini-css-extract-plugin
module.exports = {"root":"slider-nav-buttons_root__kLUdv","buttons":"slider-nav-buttons_buttons__EohHZ","counters":"slider-nav-buttons_counters__bn_6S"};